import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

export const useGetDirectFormTotalFields = () => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const TOTAL_FIELDS = {
      NET_INCREASE_DECREASE_CASH_EQUIVALENTS: {
        name: 'netIncreaseDecreaseCashEquivalents',
        title: t('financialPlan.projectedCashFlow.direct.netIncreaseDecreaseCashEquivalents'),
      },
      CASH_EQUIVALENTS_BEGINNING_PERIOD: {
        name: 'cashEquivalentsBeginningPeriod',
        title: t('financialPlan.projectedCashFlow.direct.cashEquivalentsBeginningPeriod'),
      },
      CASH_EQUIVALENTS_END_PERIOD: {
        name: 'cashEquivalentsEndPeriod',
        title: t('financialPlan.projectedCashFlow.direct.cashEquivalentsEndPeriod'),
      },
    } as const;
    return TOTAL_FIELDS;
  }, [t, i18n]);
};

export const TOTAL_FIELDS = {
  NET_INCREASE_DECREASE_CASH_EQUIVALENTS: {
    name: 'netIncreaseDecreaseCashEquivalents',
    title: t('financialPlan.projectedCashFlow.direct.netIncreaseDecreaseCashEquivalents'),
  },
  CASH_EQUIVALENTS_BEGINNING_PERIOD: {
    name: 'cashEquivalentsBeginningPeriod',
    title: t('financialPlan.projectedCashFlow.direct.cashEquivalentsBeginningPeriod'),
  },
  CASH_EQUIVALENTS_END_PERIOD: {
    name: 'cashEquivalentsEndPeriod',
    title: t('financialPlan.projectedCashFlow.direct.cashEquivalentsEndPeriod'),
  },
} as const;

export const DEFAULT_DEBOUNCE_TIME_DIRECT_FORM = 700;
